import {SET_SHOW_COMPLETED} from 'redux/reducers/elearning/action-types'

const setShowCompleted = (value) => ({
	type: SET_SHOW_COMPLETED,
	value
});

export {setShowCompleted}